import { Link, useLocation } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_form-manage/artifacts/dwtsdzv7_WhatsApp%20Image%202026-05-25%20at%208.11.14%20PM.jpeg";

const NAV = [
    { to: "/", label: "Home", testId: "nav-home" },
    { to: "/about", label: "About", testId: "nav-about" },
    { to: "/membership", label: "Membership", testId: "nav-membership" },
    { to: "/committee", label: "Committee", testId: "nav-committee" },
    { to: "/events", label: "Events", testId: "nav-events" },
    { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export default function PublicHeader() {
    const { pathname } = useLocation();
    return (
        <header data-testid="public-header" className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-[#E2E8F0]">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-6">
                <Link to="/" data-testid="logo-link" className="flex items-center gap-3 shrink-0">
                    <div className="h-12 w-12 bg-black flex items-center justify-center overflow-hidden">
                        <img src={LOGO} alt="STMF" className="h-full w-full object-cover" />
                    </div>
                    <div className="leading-tight hidden sm:block">
                        <div className="font-display font-bold text-[#0F172A] tracking-tight text-base">STMF</div>
                        <div className="text-[10px] uppercase tracking-[0.18em] text-[#64748B]">Surat Texmac Federation</div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-7">
                    {NAV.map((n) => (
                        <Link key={n.to} to={n.to} data-testid={n.testId}
                            className={`text-sm font-medium transition-colors ${pathname === n.to ? "text-[#0F172A]" : "text-[#64748B] hover:text-[#0F172A]"}`}>
                            {n.label}
                        </Link>
                    ))}
                    <Link to="/admin/login" data-testid="nav-admin" className="text-sm font-medium text-[#64748B] hover:text-[#0F172A]">Admin</Link>
                </nav>

                <Link to="/apply" data-testid="header-cta-apply"
                    className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-[#0F172A] text-white text-sm font-medium hover:bg-[#1E293B] transition-colors shrink-0">
                    Become a Member <span className="text-[#D4AF37]">→</span>
                </Link>
            </div>
        </header>
    );
}
